import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import QAUpload from '../../container/modules/qa/QAUpload';

const Profile = lazy(() => import('../../container/modules/profile/index.js'));
const NotFound = lazy(() => import('../../container/pages/404'));
const UploadAndEncoding = lazy(() => import('../../container/modules/uploads/UploadsEncoding.js'));
const Encoding = lazy(() => import('../../container/modules/uploads/Encoding.js'));
const UploadDocumentList = lazy(() => import('../../container/modules/uploads/List'));
const UploadBatchHeader = lazy(() => import('../../container/modules/uploads/BatchHeader'));
const UploadFiles = lazy(() => import('../../container/modules/uploads/Files'));
const Reprocess = lazy(() => import('../../container/modules/reprocess/Reprocess'));
const ReprocessView = lazy(() => import('../../container/modules/reprocess/ReprocessView'));
const Search = lazy(() => import('../../container/modules/search/Search'));
const SearchView = lazy(() => import('../../container/modules/search/SearchView'));
const HQView = lazy(() => import('../../container/modules/search/HQView.js'));
const GroupView = lazy(() => import('../../container/modules/search/GroupView'));
const BatchControlView = lazy(() => import('../../container/modules/search/BatchControlView'));
const QAList = lazy(() => import('../../container/modules/qa/QAList'));
const QAFormUpload = lazy(() => import('../../container/modules/qa/QAUpload'));
const QAFormReview = lazy(() => import('../../container/modules/qa/QAReview'));
const QAFormView = lazy(() => import('../../container/modules/qa/QAView'));
const ReportGeneration = lazy(() => import('../../container/modules/reports/report'));
const AuditTrail = lazy(() => import('../../container/modules/settings/auditTrail/AuditTrail.js'));
const AuditTrailView = lazy(() => import('../../container/modules/settings/auditTrail/AuditTrailView.js'));
const CancellationManagement = lazy(() => import('../../container/modules/settings/cancellation/CancellationManagement'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="profile" element={<Profile />} />
      <Route path="upload" element={<UploadAndEncoding />} />
      <Route path="encoding" element={<Encoding />} />
      <Route path="upload/batch-header" element={<UploadBatchHeader />} />
      <Route path="upload/files" element={<UploadFiles />} />
      <Route path="reprocess" element={<Reprocess />} />
      <Route path="reprocess/view" element={<ReprocessView />} />
      <Route path="search" element={<Search />} />
      <Route path="search/view" element={<SearchView />} />
      <Route path="search/hq-search/view" element={<HQView />} />
      <Route path="search/group-search/view" element={<GroupView />} />
      <Route path="search/batch-control/view" element={<BatchControlView />} />
      <Route path="index-form" element={<QAList />} />
      <Route path="index-form/upload" element={<QAFormUpload />} />
      <Route path="index-form/review" element={<QAFormReview />} />
      <Route path="index-form/view" element={<QAFormView />} />
      <Route path="report-generation" element={<ReportGeneration />} />
      <Route path="audit-trail" element={<AuditTrail />} />
      <Route path="audit-trail/view" element={<AuditTrailView />} />
      <Route path="cancellation-mngmt" element={<CancellationManagement />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PagesRoute;
